export default "__VITE_ASSET__BtXg$Hoo__"